/**
 * Created by vxg on 2019/06/12.
 */
import request from '../utils/request'
const serviceName = 'workflow';
export function queryUserTask(bizId) {
  return request({
    url:`/${serviceName}/commonFlow/queryUserTask?bizPk=${bizId}&forward=0`,
    method:'get'
  })
}

export function getProcessActiveTask(bizId) {
  return request({
    url:`/${serviceName}/commonFlow/getProcessActiveTask?bizPk=${bizId}`,
    method:'get'
  })
}

export function getFlowToolbar(data) {
  return request({
    url:`/${serviceName}/commonFlow/getFlowToolbar`,
    method:'post',
    data
  })
}

export function workflowPass(data) {
  return request({
    url:`/${serviceName}/commonFlow/pass`,
    method:'post',
    data
  })
}

export function bjcaGenSign(bizPk, actionVar) {
  return request({
    url:`/bjca/server/genSign/${bizPk}/${actionVar}`,
    method:'post'
  })
}

export function noticeData(data) {
    return request({
      url:`/jtsq/tz/main/list?page=1&rows=20`,
      method:'post',
      data:data
    })
  }



// WEBPACK FOOTER //
// ./src/api/workflow.js